<template>
    <div v-if="warningZone">
        <!-- <h1>Estas con Nosotros?</h1> -->
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            events: [
                "click",
                "mousemove",
                "mousedown",
                "scroll",
                "keypress",
                "load",
            ],
            warningTimer: null,
            logoutTimer: null,
            reloadPageTimer: null,
            warningZone: false,
        };
    },
    created() {},
    mounted() {
        this.events.forEach(function (event) {
            window.addEventListener(event, this.resetTimer);
        }, this);

        this.setTimers();

        
    },
    destroyed() {
        this.events.forEach(function (event) {
            window.removeEventListener(event, this.resetTimer);
        }, this);

        this.setTimers();
    },
    methods: {
        setTimers: function () {
            this.reloadPageTimer = setTimeout(this.reloadPage, 45 * 60 * 1000);
        },
        warningMessage: function () {
            this.warningZone = true;
        },
        reloadPage() {
            this.$router.go(this.$router.currentRoute);
        },
        logoutUser: function () {},
        resetTimer: function () {
            clearTimeout(this.warningTimer);
            clearTimeout(this.logoutTimer);
            clearTimeout(this.reloadPageTimer);

            this.setTimers();
        },
    },
};
</script>

<style></style>
